import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/chat-file.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-228c0777")

_pushScopeId("data-v-228c0777")
const _hoisted_1 = { class: "chat-block" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  style: {"font-size":"20px"},
  class: "chat-title"
}
const _hoisted_4 = { class: "chat-container" }
const _hoisted_5 = {
  id: "messages-container",
  class: "chat-messages-container"
}
const _hoisted_6 = {
  key: 0,
  class: "chat-date-title"
}
const _hoisted_7 = { ref: "labelToday" }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { class: "msg-text-block" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  style: {"margin-inline-end":"8px"},
  src: _imports_0
}, null, -1)
const _hoisted_11 = {
  class: "msg-text",
  style: {"align-self":"center"}
}
const _hoisted_12 = {
  key: 0,
  class: "msg-text"
}
const _hoisted_13 = { class: "msg-date" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.orderQuoteId)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('chat.chatType.chat')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredChatMessages, (row) => {
          return (_openBlock(), _createBlock("div", {
            key: row.id,
            class: ["message-item", [row.type == _ctx.ChatMessageType.Provider ? 'from-me' : 'from-index']]
          }, [
            (row.isToday)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t('chat.today')) + " ", 1),
                    _hoisted_8
                  ], 512)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_9, [
              (row.attachmentPath)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    style: {"display":"inline-flex"},
                    href: row.attachmentPath
                  }, [
                    _hoisted_10,
                    _createVNode("span", _hoisted_11, _toDisplayString(row.attachmentName), 1)
                  ], 8, ["href"]))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                (row.message)
                  ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(row.message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("span", _hoisted_13, _toDisplayString(_ctx.formatChatDate(row.createdAt)), 1)
          ], 2))
        }), 128))
      ])
    ])
  ]))
})